import React from 'react';
import { boxes } from './data';
import { PAGE_3 } from './assets';
import styles from './BarContainer.module.scss';

interface IProps {
    groupID: string
    onArrowUp: () => void
    onArrowDown: () => void
}

export default function BarContainer(props: IProps) {

    return (
        <>
            <div className={styles["arrow-container"]}>
                <img src={PAGE_3.ARROW_UP.default} alt="Arrow up" onClick={props.onArrowUp} className={styles["arrow-up"]} />
            </div>
            <div className={styles["road-container"]}>
                <img src={PAGE_3.ROAD.default} alt="Road" />
                <div className={styles["box-container"]}>
                    <div className={styles["block-container"]}></div>
                    {boxes.map((item, key) => {
                        return (
                            <div className={styles["boxes"]}>
                                <img src={item.box} alt="Box" />
                                <img src={item.frame}
                                    alt="Frame"
                                    className={key + 1 === parseInt(props.groupID) ? styles["frame"] : styles["frame-hidden"]}
                                />
                            </div>
                        )
                    })}
                    <div className={styles["block-container"]}></div>
                </div>
            </div>
            <div className={styles["arrow-container"]}>
                <img src={PAGE_3.ARROW_DOWN.default} alt="Arrow down" onClick={props.onArrowDown} className={styles["arrow-down"]} />
            </div>
        </>
    )
}